export default class BaseTagManager {
  constructor(tagManager) {
    this.tagManager = tagManager;
  }

  async pushEvent(data) {}
}
